module.exports = __webpack_public_path__ + "img/yandex.e2cb9e82.gif";